export default "__VITE_ASSET__Dwf5AHOd__"